



import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { FetchData, Toast } from "../../customHooks/customHooks";
import { CREATE_STATUS_MASTER,  DELETE_STATUS_MASTER, GET_STATUS_MASTER,  UPDATE_STATUS_MASTER, } from "../../api";

// -- Async Thunk to Get User Profile --
export const GetAllMasterStatus = createAsyncThunk('getAllStatus', async (body, { rejectWithValue }) => {

    try {
        const response = await FetchData(GET_STATUS_MASTER, body);

        if (!response) throw new Error("No response received");

        if (response.status === 200) {
            let { data } = response.data
            return { status: 200, data } // ✅ Return the actual user profile data
        } else if (response.status === 401) {
            return rejectWithValue("Unauthorized");
        } else {
            return rejectWithValue("Failed to fetch user profile");
        }
    } catch (err) {
        console.log("Error fetching user profile:", err);
        return rejectWithValue(err.message || "Something went wrong");
    }
});

// -- Slice --
const GetAllStatusMasterSlice = createSlice({
    name: 'Customer',
    initialState: {
        StatusMaster: [],
        loading: false,
        error: null
    },
    extraReducers: (builder) => {
        builder
            .addCase(GetAllMasterStatus.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(GetAllMasterStatus.fulfilled, (state, action) => {
                state.StatusMaster = action.payload; // ✅ Store fetched profile
                state.loading = false;
            })
            .addCase(GetAllMasterStatus.rejected, (state, action) => {
                state.error = action.payload || action.error.message;
                state.loading = false;
            });
    }
});


const StatusMasterDetailsSlice = createSlice({
    name: 'Status Master Details',
    initialState: {
        StatusMaster: ''
    },
    reducers: {
        setStatusMasterDetail: (state, action) => {
            state.StatusMaster = action.payload;
        }
    }
});

export const CreateSattusMaster = createAsyncThunk('createSattusMaster', async (body, { rejectWithValue }) => {

    try {
        const response = await FetchData(CREATE_STATUS_MASTER, body);

        if (!response) throw new Error("No response received");

        if (response.status === 200) {
            if (response?.data?.apiStatus?.statusCode === '200') {
                Toast('success', response?.data?.apiStatus?.statusMessage)
                return { status: 200 }
            } else {
                Toast('error', response?.data?.apiStatus?.statusMessage)
                return { status: response?.data?.apiStatus?.statusMessage }
            }
        } else if (response.status === 401) {
            return rejectWithValue("Unauthorized");
        } else {
            return rejectWithValue("Failed to fetch user profile");
        }
    } catch (err) {
        console.log("Error fetching user profile:", err);
        return rejectWithValue(err.message || "Something went wrong");
    }
});

export const UpdateStatusMaster = createAsyncThunk('updateStatusMaster', async (body, { rejectWithValue }) => {

    try {
        const response = await FetchData(UPDATE_STATUS_MASTER, body);

        if (!response) throw new Error("No response received");

        if (response.status === 200) {
            if (response?.data?.apiStatus?.statusCode === '200') {
                Toast('success', response?.data?.apiStatus?.statusMessage)
                return { status: 200 }
            } else {
                Toast('error', response?.data?.apiStatus?.statusMessage)
                return { status: response?.data?.apiStatus?.statusMessage }
            }
        } else if (response.status === 401) {
            return rejectWithValue("Unauthorized");
        } else {
            return rejectWithValue("Failed to fetch user profile");
        }
    } catch (err) {
        console.log("Error fetching user profile:", err);
        return rejectWithValue(err.message || "Something went wrong");
    }
});

export const DeleteStatusMaster = createAsyncThunk('deleteStatusMaster', async (id, { rejectWithValue }) => {

    try {
        const response = await FetchData(DELETE_STATUS_MASTER, { statusMasterID: id });

        if (!response) throw new Error("No response received");

        if (response.status === 200) {
            if (response?.data?.apiStatus?.statusCode === '200') {
                Toast('success', response?.data?.apiStatus?.statusMessage)
                return { status: 200 }
            } else {
                Toast('error', response?.data?.apiStatus?.statusMessage)
                return { status: response?.data?.apiStatus?.statusMessage }
            }
        } else if (response.status === 401) {
            return rejectWithValue("Unauthorized");
        } else {
            return rejectWithValue("Failed to fetch user profile");
        }
    } catch (err) {
        console.log("Error fetching user profile:", err);
        return rejectWithValue(err.message || "Something went wrong");
    }
});




export const { setStatusMasterDetail } = StatusMasterDetailsSlice.actions
export {
    GetAllStatusMasterSlice,
    StatusMasterDetailsSlice,
};
